"use client";
import { useState } from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
const faqs = [
    {
        question: "How often is dialysis required?",
        answer: "Most patients need dialysis two to three times per week, depending on their kidney function and overall health condition. The nephrologist determines the frequency based on medical evaluation.",
    },
    {
        question: "Is dialysis painful?",
        answer: "Dialysis is generally not painful. Some patients may experience mild discomfort during needle insertion, but the procedure itself is usually well tolerated.",
    },
    {
        question: "How long does each dialysis session last?",
        answer: "A typical hemodialysis session lasts 3 to 4 hours. The duration may vary depending on the patient’s medical condition.",
    },
    {
        question: "Can dialysis patients live a normal life?",
        answer: "Yes. With proper treatment, medication, dietary management, and regular follow-ups, many dialysis patients lead active and productive lives.",
    },
    {
        question: "Is emergency dialysis available in Patna?",
        answer: "Yes. HDNA Aarogyam Hospital provides emergency dialysis services for patients requiring urgent renal support.",
    },
    {
        question: "What are the different types of dialysis available?",
        answer: "There are two main types:",
        points: [
            "Hemodialysis – Blood is filtered using a dialysis machine.",
            "Peritoneal Dialysis – The abdominal lining acts as a natural filter.",
        ],
        note: "Our nephrologists recommend the most suitable option after evaluation."
    },
    {
        question: "Who needs dialysis treatment?",
        answer: "Dialysis is required for patients with:",
        points: [
            "Chronic Kidney Disease (CKD)",
            "End-Stage Renal Disease (ESRD)",
            "Acute Kidney Injury",
            "Severe electrolyte imbalance",
            "Fluid overload conditions"
        ],
    },
    {
        question: "What precautions should dialysis patients follow?",
        answer: "Patients should:",
        points: [
            "Follow a kidney-friendly diet",
            "Limit fluid intake as advised",
            "Take prescribed medications regularly",
            "Attend all scheduled dialysis sessions",
            "Monitor blood pressure and blood sugar levels"
        ],
    },
    {
        question: "How is dialysis access created for treatment?",
        answer: "For hemodialysis, a vascular access (usually an AV fistula, graft, or catheter) is created to allow safe and efficient blood flow during treatment.",
    },
    {
        question: "Why choose HDNA Aarogyam Hospital for dialysis care in Patna?",
        answer: "Patients choose HDNA Aarogyam Hospital because of:",
        points: [
            "Experienced nephrology specialists",
            "Advanced dialysis machines",
            "Strict infection control protocols",
            "Personalized patient care",
            "Emergency support availability"
        ],
    },
]
export default function FaqSection() {
    const [activeIndex, setActiveIndex] = useState(null);
    const leftFaqs = faqs.slice(0, 5);
    const rightFaqs = faqs.slice(5, 10);
    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const renderFaqs = (faqList, offset) =>
        faqList.map((faq, index) => {
            const currentIndex = index + offset;
            return (
                <div key={currentIndex} className="faq-box" onClick={() => toggleFaq(currentIndex)} >
                    {/* Question */}
                    <div className={`faq-question ${activeIndex === currentIndex ? "active" : ""}`}>
                        <h6>{faq.question}</h6>
                        <span className="icon"> {activeIndex === currentIndex ? "−" : "+"}</span>
                    </div>
                    {/* Answer */}
                    {activeIndex === currentIndex && (
                        <div className="faq-answer">
                            <p>{faq.answer}</p>

                            {faq.points && (
                                <ul className="faq-points">
                                    {faq.points.map((point, i) => (
                                        <li key={i}>
                                            <span className="point-icon"><MdKeyboardArrowRight /></span>
                                            {point.includes("Hemodialysis") || point.includes("Peritoneal Dialysis") ? (
                                                <><strong>{point.split(" – ")[0]}</strong> – {point.split(" – ")[1]}</>
                                            ) : (
                                                point
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            )}
                            {faq.note && <p className="faq-note">{faq.note}</p>}
                        </div>
                    )}
                </div>
            );
        });

    return (
        <section className="faq-section container">
            <div className="row">
                {/* Left Column */}
                <div className="col-lg-6">{renderFaqs(leftFaqs, 0)}</div>
                {/* Right Column */}
                <div className="col-lg-6">{renderFaqs(rightFaqs, 5)}</div>
            </div>
        </section>
    );
}

